import type { ExtendedAxiosError } from '../../services/settingsApi/types';

export const getHeaderFromError = (
  error: ExtendedAxiosError,
  key: string,
) => {
  return error?.config?.headers?.[key];
};
